import { BaseClient } from '../client';
import { veiculosMarcas } from '../offer/offer.mocks';
import { TVeiculoMarca } from '../offer/offer.types';

export const getAdminVehicleBrands = async () => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return veiculosMarcas;
	// }

	try {
		const response = await BaseClient.get<TVeiculoMarca[]>(`/VeiculoMarcas`).then((response) => response.data);

		return response;
	} catch (error) {
		throw error;
	}
};
